// Compact quick-reaction row shown before opening full picker.
export const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏", "🔥", "👏"];

// Local storage key for recently used reactions.
export const RECENT_REACTIONS_KEY = "chat.recentReactions";
